export default __webpack_public_path__ + "static/media/nonagon-icon.dcf5dba9.svg";